import { Injectable } from '@angular/core';
import { ILineMsgTemplate, ISignedUrl } from '@blcloud/bl-datamodel';
import { LineMsgType } from '@blcloud/bl-datamodel/enum/sns/line-msg-type';
import { SnsMsgTemplateUseDiv } from '@blcloud/bl-datamodel/enum/sns/sns-msg-template-use-div';
import {
  BlConditionType,
  BlApiQueryParams,
  BlApiSearchCondition,
  BlApiConditionHelper
} from '@blcloud/bl-ng-common';
import { LineMsgTemplateResource, SnsPublicTemplateResourceResource } from '@blcloud/bl-ng-resource';
import { SnsPublicTemplateResourceType } from '@blcloud/bl-datamodel/enum/sns/sns-public-template-resource-type';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

/**
 * DM案内文設定詳細メールサービス
 */
@Injectable()
export class SnsSendMessageContentService {

  /** コンストラクタ */
  constructor(
    private lineMsgTemplateResource: LineMsgTemplateResource,
    private snsPublicTemplateResourceResource: SnsPublicTemplateResourceResource,
  ) { }

  /**
   * LINEメッセージテンプレートを全て取得する
   * @returns LINEメッセージテンプレート配列
   */
  public getLineMsgTemplate(): Observable<ILineMsgTemplate[]> {
    const conditions = [
      {
        key: 'lineMsgType',
        value: LineMsgType.FlexMessage,
        type: BlConditionType.Equal,
      },
      {
        key: 'snsMsgTemplateUseDiv',
        value: SnsMsgTemplateUseDiv.DmIssueCustomTemplate,
        type: BlConditionType.Equal,
      }
    ];
    const param = new BlApiQueryParams();
    const condition = new BlApiSearchCondition();
    condition.addCondition(BlApiConditionHelper.conditionInfosToStrAndCondition(conditions));
    param.setCondition(condition);
    param.addSortField('lineMsgTemplateTypeDispOrder', false);
    return this.lineMsgTemplateResource.getList<ILineMsgTemplate>(
      param, {entityOptions: {exPath: 'cachesearch'}}
      ).pipe(
        map(response => response ? response.searchResultList : [])
      );
  }

  /**
   * LINEメッセージテンプレートのイメージ画像URLを取得する
   * @returns 署名付きURL配列配列
   */
  public getLineTemplateImageUrl(): Observable<ISignedUrl[]> {
    return this.snsPublicTemplateResourceResource.post(
      {
        snspublictemplateresourcetype: SnsPublicTemplateResourceType.LineCustomTemplateImageList,
      },
      {
        entityOptions: { operation: 'downloadlinklist' },
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/sns-send-message-modal/content/sns-send-message-content.service.ts